import { SCError } from "@next-platform/packages-ts-types";
const { ERROR_CODE_PREFIX } = SCError || {};
export const compareErrorCode = (errorCode, errorType) => {
    if (!errorCode || !errorType) {
        return false;
    }
    return `${ERROR_CODE_PREFIX}-${errorType}` === errorCode;
};
